'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoDatabase = function GoDatabase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 37.5c-8.3 0-15-2.2-15-5v-5c0-0.4 0.2-0.8 0.5-1.2 1.7 2.1 7.5 3.7 14.5 3.7s12.8-1.6 14.5-3.7c0.3 0.4 0.5 0.8 0.5 1.2v5c0 2.8-6.7 5-15 5z m0-10c-8.3 0-15-2.2-15-5v-5c0-0.3 0.1-0.5 0.2-0.8 0.1-0.1 0.2-0.3 0.3-0.4 1.7 2.1 7.5 3.7 14.5 3.7s12.8-1.6 14.5-3.7c0.1 0.1 0.2 0.3 0.3 0.4 0.1 0.3 0.2 0.5 0.2 0.8v5c0 2.8-6.7 5-15 5z m0-10c-8.3 0-15-2.2-15-5v-5c0-2.8 6.7-5 15-5 8.3 0 15 2.2 15 5v5c0 2.8-6.7 5-15 5z m0-12.5c-5.5 0-10 1.1-10 2.5s4.5 2.5 10 2.5 10-1.1 10-2.5-4.5-2.5-10-2.5z' })
        )
    );
};

exports.default = GoDatabase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/database.js
// module id = 1689
// module chunks = 0